import React, {useCallback, useEffect, useState} from 'react';
import {useScrollLock} from '@hooks/useScrollLock';
import CodeInput from "@core/inputs/CodeInput";
import {showError} from "@utils/helpers";
import TableOrderService from "@services/TableOrderService";
import DefaultButton from "@core/buttons/electrons/DefaultButton";
import {useTranslation} from "react-i18next";

const SmsCode = ({phoneNumber, isOpen, modalState, onClose, onSuccess, generateNewToken}) => {
  const { t } = useTranslation();
  const {unlockScroll, lockScroll} = useScrollLock();
  const [key, setKey] = useState(0);
  const [code, setCode] = useState('');

  const close = useCallback((event) => {
    event.stopPropagation();
    modalState(false);
    setCode('');
    if (onClose) onClose();
  }, [onClose, modalState]);

  useEffect(() => {
    isOpen ? lockScroll() : unlockScroll();
  }, [isOpen, lockScroll, unlockScroll]);

  useEffect(() => {
    if (code && code.length === 4) {
      generateNewToken().then((reCaptchaToken) => {
        TableOrderService.verifyPhoneNumber(
          phoneNumber,
          code,
          reCaptchaToken
        )
          .then((response) => {
            if (response.data === 'NUMBER_VERIFICATION_FAILED') {
              showError(t('verificationCodeWasNotCorrect'))
              return
            }
            setCode('');
            modalState(false);
            onSuccess();
          })
          .catch((err) => {
            setKey(key + 1);
            showError(err.response.data.message);
          })
      })
    }
  }, [code]);

  return (
    <main
      className={`fixed overflow-hidden z-30 bg-gray-900 bg-opacity-25 inset-0 mx-auto ${
        isOpen
          ? 'transition-opacity opacity-100 duration-500'
          : 'transition-opacity opacity-0 delay-500 translate-x-full'
      }`}
      data-testid="product-preview"
    >
      <div className="flex justify-center"
      >
        <section
          style={{maxWidth: 600}}
          className={`w-full bottom-0 absolute bg-white h-1/2 shadow-xl delay-400 duration-500 ease-in-out transition-all transform rounded-t-3xl ${
            isOpen ? 'translate-y-0' : 'translate-y-full'
          }`}
        >
          <article
            className="relative w-full flex flex-col space-y-6 h-full justify-center align-middle p-6 items-center mx-auto">
            <>
              <div>
                <h2 className="mt-6 text-3xl font-extrabold text-gray-900">{t('confirmationCode')}</h2>
                <p className="mt-2 font-normal text-sm text-gray-300">{t('enterThe4DigitCodeThatWeSentViaSMS')}</p>
              </div>
              <div className="mt-8 space-y-6">
                <CodeInput key={key} value={code} onChange={(value) => setCode(value)}/>
              </div>
            </>
            <div className="flex flex-row-reverse w-full">
              <DefaultButton textColor='text-white'
                             label={t('close')} onClick={close} rounded='rounded-2xl'/>
            </div>
          </article>
        </section>
      </div>
      <section className="w-full h-full cursor-pointer" onClick={close}/>
    </main>
  );
};

export default SmsCode;
